import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  TextField,
} from "@mui/material";
import { useState } from "react";
import { colors, fonts, size } from "../../ColorFont/color";

const EditHrsPopup = ({ open, onClose, selectedSellerId, handleEditHrs }) => {
  const [hrs, setHrs] = useState("");

  const handleHrsChange = (event) => {
    setHrs(event.target.value);
  };

  const handleSubmit = () => {
    handleEditHrs(selectedSellerId, hrs);
    onClose();
  };

  return (
    <Dialog open={open} onClose={onClose}>
      <DialogTitle
        sx={{
          fontFamily: fonts.poppins,
          fontSize: size.title,
          fontWeight: 600,
          color: colors.primary_dark,
        }}
      >
        Edit Hours
      </DialogTitle>
      <DialogContent>
        <TextField
          label="Hours"
          type="number"
          value={hrs}
          onChange={handleHrsChange}
          fullWidth
          margin="dense"
          size="small"
        />
      </DialogContent>
      <DialogActions>
        <Button
          variant="contained"
          size="small"
          sx={{ fontFamily: fonts.poppins, backgroundImage: colors.button }}
          onClick={onClose}
        >
          Cancel
        </Button>
        <Button
          variant="contained"
          size="small"
          sx={{ fontFamily: fonts.poppins, backgroundImage: colors.button }}
          onClick={handleSubmit}
        >
          Save
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default EditHrsPopup;
